module.exports = __webpack_public_path__ + "img/lca.1c3a5554.svg";